const throttle = (fn, delay) => {
    let timeoutID = null;
    let lastCall = 0;
    return function (...args) {
        const now = Date.now();
        if (now - lastCall >= delay) {
            if (timeoutID) {
                clearTimeout(timeoutID);
                timeoutID = null;
            }
            lastCall = now;
            fn.apply(this, args);
        }
        else {
            if (!timeoutID) {
                const remaining = delay - (now - lastCall);
                timeoutID = setTimeout(() => {
                    lastCall = Date.now();
                    timeoutID = null;
                    fn.apply(this, args);
                }, remaining);
            }
        }
    };
};
export default throttle;
